import { useState } from "react";
import { ICONS, BrandIcon } from "@/lib/icons";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Check, ChevronDown } from "lucide-react";

export default function IconPicker({ value, onChange, testId }) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");

    const entries = Object.entries(ICONS).filter(([key, meta]) => {
        if (!query.trim()) return true;
        const q = query.trim().toLowerCase();
        return key.includes(q) || meta.label.toLowerCase().includes(q);
    });

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    type="button"
                    variant="outline"
                    className="h-10 gap-2 border-white/10 bg-zinc-900 text-zinc-200 hover:bg-white/5"
                    data-testid={testId}
                >
                    <BrandIcon name={value} size={18} />
                    <span className="text-xs text-zinc-500 uppercase tracking-wider">Icon</span>
                    <ChevronDown className="h-3.5 w-3.5 text-zinc-500" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-72 p-3 bg-zinc-900 border-white/10 text-zinc-100" align="start">
                <Input
                    autoFocus
                    placeholder="Search icons…"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    className="h-9 mb-3 bg-zinc-950 border-white/10 text-zinc-100 placeholder:text-zinc-500"
                />
                <div className="grid grid-cols-6 gap-1 max-h-64 overflow-y-auto">
                    {entries.map(([key, meta]) => {
                        const selected = key === value;
                        return (
                            <button
                                key={key}
                                type="button"
                                onClick={() => {
                                    onChange(key);
                                    setOpen(false);
                                }}
                                className={`aspect-square rounded-md flex items-center justify-center border transition-colors bg-white ${
                                    selected
                                        ? "ring-2 ring-brand border-transparent"
                                        : "border-white/10 hover:opacity-80"
                                }`}
                                title={meta.label}
                                data-testid={`icon-option-${key}`}
                            >
                                {selected ? (
                                    <Check className="h-4 w-4 text-brand" />
                                ) : (
                                    <BrandIcon name={key} size={18} />
                                )}
                            </button>
                        );
                    })}
                </div>
            </PopoverContent>
        </Popover>
    );
}
